import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import transfereeService from "../../services/transferees";
import transfereeServices from "../../services/transferees";

export interface transfereesPageState {
  history: any;
  countryData?: any;
  transferees: {
    table: any[];
    count?: number;
  };
  loading: boolean;
  error?: string;
  transfereeDetails?: any;

  transfereeHistoryList: any;
  count: number;
  historyDetails?: any;
}

const initialState: transfereesPageState = {
  error: undefined,
  countryData: [],
  history: [],
  loading: false,
  transferees: {
    table: [],
    count: 0,
  },
  transfereeHistoryList: [],
  count: 0,
};

export const getCountries = createAsyncThunk("user/Login", async () => {
  return transfereeService.getCountries();
});

export const getAllTransferees = createAsyncThunk(
  "transferees/fetch_all",
  async (body: any) => {
    const response = transfereeServices.getAllTransferees(body);

    return response;
  },
);
export const getTransfereeHistory = createAsyncThunk(
  "history/get-transferee-history",
  async (filterData: any) => {
    const response = transfereeServices.getTransfereeHistory(filterData);

    return response;
  },
);

const transfereeSlice = createSlice({
  name: "transfereesPageReduce",
  initialState,
  reducers: {},
  extraReducers(builder): void {
    builder.addCase(getCountries.pending, (state) => {
      state.countryData = ["Andorra1", "Angola2"];
    });
    builder.addCase(getCountries.fulfilled, (state, action) => {
      state.countryData = ["Andorra3", "Angola5"];
    });
    builder.addCase(getCountries.rejected, (state, action) => {
      state.countryData = ["Andorra6", "Angola7"];
      state.error = action?.error?.message;
    });

    // get transferee history
    builder.addCase(getTransfereeHistory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTransfereeHistory.fulfilled, (state, action: any) => {
      state.loading = false;
      state.transfereeHistoryList = action.payload;
      state.count = action.payload.Count;
    });
    builder.addCase(getTransfereeHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.error?.message;
    });

    //get all exceptions
    builder.addCase(getAllTransferees.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllTransferees.fulfilled, (state, action) => {
      state.loading = false;

      if ("transferees" in action.payload && "totalCount" in action.payload) {
        const { totalCount, transferees } = action.payload;

        const onTop = [
          {
            id: "5319",
            firstName: "Emberly",
            lastName: "Bowers",
            policyId: "295",
            policyName: "US Domestic Homeowner",
            consultantName: "Tiffany Vine",
            fileNumber: "6667-00129",
            miloId: "42086",
            clientId: "200",
            clientName: "Demo Client",
            divisionName: null,
            tempLivingOptions: 0,
            tlrId: null,
            expenseSubmissionCount: 0,
            origin: "Elwood, IN, United States",
            destination: "ChesterPennsylvania, United States",
            status: "ACTIVE",
            notification: null,
            authorizationDate: "2024-07-11T13:34:12.000Z",
            new: false,
          },
          {
            id: "5290",
            firstName: "Mateo",
            lastName: "Thompson",
            policyId: "296",
            policyName: "US Domestic Renter",
            consultantName: "Tiffany Vine",
            fileNumber: "6667-00172",
            miloId: "42148",
            clientId: "200",
            clientName: "Demo Client",
            divisionName: null,
            tempLivingOptions: 0,
            tlrId: null,
            expenseSubmissionCount: 0,
            origin: "Alpine, Utah, United States",
            destination: "Green BayWisconsin, United States",
            status: "ACTIVE",
            notification: null,
            authorizationDate: "2024-03-12T20:07:45.000Z",
            new: false,
          },
          {
            id: "5291",
            firstName: "Haley",
            lastName: "DeLeo",
            policyId: "298",
            policyName: "International LTA",
            consultantName: "Elizabeth Fox",
            fileNumber: "6667-00146",
            miloId: "42122",
            clientId: "200",
            clientName: "Demo Client",
            divisionName: null,
            tempLivingOptions: 1,
            tlrId: "1707",
            expenseSubmissionCount: 3,
            origin: "Montreal, Quebec, Canada",
            destination: "OakvilleOntario, Canada",
            status: "ACTIVE",
            notification: null,
            authorizationDate: "2024-03-12T20:08:24.000Z",
            new: false,
          },
        ];

        const transfereesTemp =
          action.meta.arg.page == 1
            ? [
                ...onTop,
                ...transferees.filter(
                  (transferee: any) =>
                    !onTop.some((t) => t.id == transferee.id),
                ),
              ]
            : transferees;

        state.transferees = {
          table: transfereesTemp,
          count: totalCount,
        };
      }
    });
    builder.addCase(getAllTransferees.rejected, (state, action) => {
      state.loading = false;
      // action.payload contains error information
      state.error = action?.error?.message;
    });
  },
});

export default transfereeSlice.reducer;
